<template>
  <span v-if="lot">
    <v-chip v-if="lot.warranty_status === 'valid'" color="green" dark x-small>
      Valid
    </v-chip>
    <v-chip
      v-else-if="lot.warranty_status === 'expiring_soon'"
      color="amber darken-2"
      dark
      x-small
    >
      {{ lot.warranty_days_remaining }}d left
    </v-chip>
    <span v-else-if="lot.warranty_status === 'expired'">
      <v-chip color="red" dark x-small>Expired</v-chip>
      <span v-if="showRmaWarning" class="red--text caption ml-1"
        >RMA at risk</span
      >
    </span>
    <v-chip v-else color="grey lighten-1" x-small>N/A</v-chip>
  </span>
  <span v-else class="grey--text caption">-</span>
</template>

<script>
export default {
  props: {
    lot: { type: Object, default: null },
    showRmaWarning: { type: Boolean, default: true },
  },
};
</script>
